var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteCommunityDetails = function SvgGradientWhiteCommunityDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.177 9.9H.725a.364.364 0 0 1-.364-.363V.367c0-.2.163-.364.364-.364h12.452c.2 0 .364.163.364.364v9.17c0 .2-.163.364-.364.364Z",
    fill: "url(#gradient-white-community-details_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.102 2.409H3.424c-.27 0-.494.219-.494.494v8.56c0 .27.219.493.494.493h11.678c.27 0 .494-.219.494-.494v-8.56a.494.494 0 0 0-.494-.493Zm-3.189 2.764H4.417V3.775h7.492v1.398h.004Zm2.443 0h-1.422V3.775h1.422v1.398Z",
    fill: "url(#gradient-white-community-details_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-community-details_svg__a",
    x1: -0.019,
    y1: 0.927,
    x2: 13.922,
    y2: 8.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-community-details_svg__b",
    x1: 9.263,
    y1: 11.953,
    x2: 9.263,
    y2: 2.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.7
  })))));
};

export default SvgGradientWhiteCommunityDetails;